module.exports = __webpack_public_path__ + "img/1.21335a29.png";